import {HttpResourceRef} from '@angular/common/http';
import {Component, inject, signal, ViewChild} from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';
import {HistoryEventBlock} from '../../../../shared/model/history-events';

import {HistoryLoaderService, HistoryLoaderV2Response} from '../../../../shared/services/history-loader.service';

@Component({
    selector: 'pm-all-history-dialog',
    templateUrl: './all-history-dialog.component.html',
    styleUrls: ['./all-history-dialog.component.scss'],
    standalone: false
})
export class AllHistoryDialogComponent {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  protected historyLoaderService = inject(HistoryLoaderService)
  private urlSignal = signal<string|null>(null);

  public historyResourceRef: HttpResourceRef<HistoryLoaderV2Response> = this.historyLoaderService.paginatedHistoryResource(
    this.urlSignal);

  identity(_: number, item: HistoryEventBlock) {
    return item.commitId;
  }

  public updatePage(newUrl?: string): void {
    this.urlSignal.set(newUrl)
  }

  expandAll() {
    this.accordion.openAll();
    return undefined;
  }

  closeAll() {
    this.accordion.closeAll();
    return undefined;

  }

  previous() {
    this.updatePage(this.historyResourceRef.value()?.links.previous);
  }

  next() {
    this.updatePage(this.historyResourceRef.value()?.links.next);
  }
}
